import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.375 28C14.6849 27.998 13.0645 27.3257 11.8694 26.1306C10.6743 24.9355 10.002 23.3151 10 21.625V8.5C10 7.30653 10.4741 6.16193 11.318 5.31802C12.1619 4.47411 13.3065 4 14.5 4C15.6935 4 16.8381 4.47411 17.682 5.31802C18.5259 6.16193 19 7.30653 19 8.5V21.625C19 22.3212 18.7234 22.9889 18.2312 23.4812C17.7389 23.9734 17.0712 24.25 16.375 24.25C15.6788 24.25 15.0111 23.9734 14.5188 23.4812C14.0266 22.9889 13.75 22.3212 13.75 21.625V8.5H15.25V21.625C15.25 21.9234 15.3685 22.2095 15.5795 22.4205C15.7905 22.6315 16.0766 22.75 16.375 22.75C16.6734 22.75 16.9595 22.6315 17.1705 22.4205C17.3815 22.2095 17.5 21.9234 17.5 21.625V8.5C17.5 7.70435 17.1839 6.94129 16.6213 6.37868C16.0587 5.81607 15.2956 5.5 14.5 5.5C13.7044 5.5 12.9413 5.81607 12.3787 6.37868C11.8161 6.94129 11.5 7.70435 11.5 8.5V21.625C11.5 22.9179 12.0136 24.1579 12.9279 25.0721C13.8421 25.9864 15.0821 26.5 16.375 26.5C17.6679 26.5 18.9079 25.9864 19.8221 25.0721C20.7364 24.1579 21.25 22.9179 21.25 21.625V8.5H22.75V21.625C22.748 23.3151 22.0757 24.9355 20.8806 26.1306C19.6855 27.3257 18.0651 27.998 16.375 28Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
